<template>
    <button class="btn-option-feedback">
        <span class="btn-option-feedback__text">{{ optionText }}</span>
    </button>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            optionText: { type: String, default: 'Ön' },
        }
    };
</script>

<style scoped src="@/css/components/btn-option-feedback.css"></style>
